import { defineFieldAdapter, type FieldTransformers } from '@libs/shared/frontend/helpers/define-field-adapter.helper';

import type { CustomerAuditLogEntityTypeEnum, components } from '@/libs/openapi';
import { fromApiUserFieldAdapter } from '@/resources/user/user.field-adapter';
import { formatDate } from '@/utils/format.util';

export const AUDIT_LOG_ENTITY_CATEGORY_LABELS: Record<CustomerAuditLogEntityTypeEnum, string> = {
  0: 'Users',
  1: 'Campaigns',
  2: 'Campaigns',
  3: 'API keys',
  4: 'Users',
  5: 'Teams',
  6: 'Users',
  7: 'Campaigns',
  8: 'Files',
  9: 'Programs',
};

export const fromApiCustomerAuditLogFieldAdapter = defineFieldAdapter({
  fields: {
    createdAt: formatDate('withTime'),
    entityType: (value: components['schemas']['CustomerAuditLogResponseDto']['entityType']) => AUDIT_LOG_ENTITY_CATEGORY_LABELS[value] ?? '',
  } satisfies FieldTransformers<components['schemas']['CustomerAuditLogResponseDto']>,
  meta: {
    getActorDisplayName: (row: components['schemas']['CustomerAuditLogResponseDto']): string => {
      const orgUser = row.createdByOrganizationUser;
      const user = row.createdByUser;
      const apiKey = row.createdByApiKey;

      let actorName: string | null = null;
      if (orgUser) {
        const name = `${orgUser.firstName ?? ''} ${orgUser.lastName ?? ''}`.trim();
        actorName = name || orgUser.email;
      } else if (user) {
        const name = fromApiUserFieldAdapter.getFullName(user);
        actorName = name || '';
      }

      if (actorName && apiKey?.name) {
        return `${actorName} via API key "${apiKey.name}"`;
      }
      return actorName ?? 'System';
    },
  },
}, 'strict');
